<template>
	<div>
		<button class="btn btn-primary my-3" v-on:click="getPolizasLog">
			<i class="material-icons">refresh</i>
		</button>
		<div class="table-responsive" v-if="polizas.length>0">
			<table class="table table-bordered table-striped">
	            <thead>
	                <tr>
	                	<th>Correlativo</th>
	                	<th>Póliza Ref.</th>
	                	<th>Cliente</th>
	                	<th>Vendedor</th>
	                    <th>Estatus</th>
	                    <th>Aseguradora</th>
	                    <th>Producto</th>
	                    <th></th>
	                </tr>
	                <tr v-if="loading">
	                	<th colspan="10" class="p-0">
	                		<preloader></preloader>
	                	</th>
	                </tr>
	            </thead>
	            <tbody>
	            	<tr v-for="poliza in polizas">
	            		<td>{{poliza.CORRELATIVO_LOG}}</td>
	            		<td>{{poliza.CODIGO_POLIZA_REF}}</td>
	            		<td>{{poliza.cliente.NOMBRE_CLIENTE}}</td>
	            		<td>{{poliza.vendedor.NOMBRE_VENDEDOR}}</td>
	                    <td v-if="poliza.ESTATUS == 'V'">Vigente</td>
	                    <td v-else>No Vigente</td>
	                    <td>{{poliza.aseguradora.DESCRIPCION_ASEGURADORA}}</td>
	                    <td>{{poliza.producto.DESCRIPCION_PRODUCTO}}</td>
	                    <td class="text-center">
	                        <button 
	                        	href="#" 
	                        	class="btn btn-table btn-sm" 
	                        	title="Ver Póliza" 
	                        	v-on:click.prevent="showPoliza(poliza)">
	                            <i class="material-icons">search</i>
	                        </button>
	                    </td>
	                </tr>
	            </tbody>
	            <tfoot v-if="false">
	            	<tr>
	            		<th colspan="3" class="text-right">
	            			Total
	            		</th>
	            		<th class="text-right px-1">
	            			
	            		</th>
	            		<td></td>
	            	</tr>
	            </tfoot>
	        </table>
	    </div>
	    <div v-else>
	    	<empty icon="hourglass_empty" title="No hay información." description="No hay historial relacionado a esta póliza.">
            </empty>
	    </div>

    	<div class="modal fade" id="modalPolizaLog" role="dialog" aria-labelledby="modal-oportunidadLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
			    <div class="modal-content">
			      	<div class="modal-header">
			        	<h5 class="modal-title" id="modal-oportunidadLabel">
			        		Ver Póliza {{form.id}} Correlativo {{form.correlativo}}
			        	</h5>
			        	<button type="button" class="btn btn-link" v-on:click="closeModalPoliza">
				        	<i class="material-icons">close</i>
				        </button>
			    	</div>
			    	<div class="modal-body">
			    		<div class="row">
			    			<div class="col-md-9">
			    				<div class="form-row">
					    			<div class="col-md-4 form-group">
					    				<label>
					    					Fecha Modificación:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.fecha">
					    			</div>

					    			<div class="col-md-4 form-group">
					    				<label>
					    					Usuario Modificó:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.usuario">
					    			</div>

					    			<div class="col-md-4 form-group">
					    				<label>
					    					Dirección IP:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.ip">
					    			</div>

					    			<div class="col-md-4 form-group">
					    				<label>
					    					Aseguradora:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.aseguradora">
					    			</div>

					    			<div class="col-md-4 form-group">
					    				<label>
					    					Cliente
					    				</label>
					    				<input 
					    					class="form-control form-control-sm" 
					    					:disabled="true"
					    					v-model="form.cliente">
					    			</div>

					    			<div class="col-md-4 form-group">
					    				<label>
					    					Vendedor:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.vendedor">
					    			</div>

					    			<div class="col-md-6 form-group">
					    				<label>
					    					Producto:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.producto">
					    			</div>

					    			<div class="col-md-6 form-group">
					    				<label>
					    					Tipo de Póliza:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.tipoPoliza">
					    			</div>

									<div class="col-md-3 form-group">
					    				<label for="vigencia_ini">
					    					Fecha Vigencia Inicial:
					    				</label>
					    				<input
					    					class="form-control form-control-sm" 
					    					id="vigencia_ini"
					    					:disabled="true"
					    					v-model="form.vigenciaIni">
					    			</div>

					    			<div class="col-md-3 form-group">
					    				<label for="vigencia_fin">
					    					Fecha Vigencia Final:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					id="vigencia_fin"
					    					:disabled="true"
					    					v-model="form.vigenciaFin">
					    			</div>

					    			<div class="col-md-6 form-group">
					    				<label>
					    					Canal de Pago:
					    				</label>
					    				<input
					    					class="form-control form-control-sm"
					    					:disabled="true"
					    					v-model="form.formaPago">
					    			</div>

					    			<div class="col-md-3 form-group">
					    				<label for="referencia">
					    					Póliza Referencia:
					    				</label>
					    				<input
					    					id="referencia"
					    					:disabled="true"
					    					v-model="form.referencia"
					    					class="form-control form-control-sm"
					    					maxlength="30">
					    			</div>

					    			<div class="col-md-3 form-group">
					    				<label>
					    					Estado:
					    				</label>
					    				<input 
					    					class="form-control form-control-sm" 
					    					v-model="form.estatus" 
					    					:disabled="true">
					    			</div>
					    		</div>	
					    		<div class="form-row">
					    			<div class="col-md-6 form-group">
					    				<label for="bien_asegurado">
					    					Bien Asegurado:
					    				</label>
					    				<textarea
					    					id="bien_asegurado"
					    					:disabled="true"
					    					v-model="form.bienAsegurado"
					    					maxlength="250"
					    					class="form-control form-control-sm"></textarea>
					    			</div>


					    			<div class="col-md-6 form-group">
					    				<label for="observaciones">
					    					Observaciones:
					    				</label>
					    				<textarea
					    					id="observaciones"
					    					:disabled="true"
					    					v-model="form.observaciones"
					    					class="form-control form-control-sm"
					    					maxlength="250"></textarea>
					    			</div>
					    		</div>
			    			</div>
			    			<div class="col-md-3">
		    					<div class="form-row mb-3 w-100">
		    						<label for="sumaAseguradaLogs" class="col-md-5">
		    							Suma Asegurada:
		    						</label>
		    						<div class="col-md-7">
			    						<input
			    							class="form-control form-control-sm"
			    							id="sumaAseguradaLogs"
			    							:disabled="true"
			    							v-model="form.sumaAsegurada"
			    							min="0">
		    						</div>
		    					</div>

		    					<div class="form-row mb-3 w-100">
		    						<label for="deducible1" class="col-md-5">
		    							Deducible 1:
		    						</label>
		    						<div  class="col-md-7">
			    						<input
			    							class="form-control form-control-sm"
			    							id="deducible1"
			    							:disabled="true"
			    							v-model="form.deducible1"
			    							min="0">
		    						</div>
		    					</div>

		    					<div class="form-row mb-3 w-100">
		    						<label for="deducible2"  class="col-md-5">
		    							Deducible 2:
		    						</label>
		    						<div  class="col-md-7">
			    						<input
			    							class="form-control form-control-sm"
			    							id="deducible2"
			    							:disabled="true"
			    							v-model="form.deducible2"
			    							min="0">
		    						</div>
		    					</div>

		    					<div class="form-row mb-3 w-100">
		    						<label for="premaNeta" class="col-md-5">
		    							Prima Neta:
		    						</label>
		    						<div class="col-md-7">
			    						<input
			    							class="form-control form-control-sm"
			    							id="premaNeta"
			    							:disabled="true"
			    							v-model="form.primaNeta"
			    							min="0">
		    						</div>
		    					</div>

		    					<div class="form-row mb-3 w-100">
		    						<label for="primaTotal" class="col-md-5">
		    							Prima Total:
		    						</label>
		    						<div class="col-md-7">
			    						<input
			    							class="form-control form-control-sm"
			    							id="primaTotal"
			    							:disabled="true"
			    							v-model="form.primaTotal"
			    							min="0">
		    						</div>
		    					</div>

		    					<div class="form-row mb-3 w-100">
		    						<div class="col-md-5">
		    							<label>
		    								Total Cobrado:
		    							</label>
		    						</div>
		    						<div class="col-md-7">
		    							<copy class="btn bg-dark text-left text-white btn-block box-shadow" :text="money(form.totalCobrado)">
				    						{{money(form.totalCobrado, true)}}
				    					</copy>	
		    						</div>
		    					</div>
			    			</div>
			    		</div>
			    	</div>
			    </div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['poliza'],

		mounted(){
			this.codigo = this.poliza;
			if (this.codigo) {
        		this.getPolizasLog();
			}

			var vm = this;
			$.fn.getPolizasLog = function (options) {
				vm.getPolizasLog();
			};
		},

		data(){
			return {
				polizas: [],
				codigo: '',
				loading: false,
				form: {
					correlativo: '',
					id: '',
					fecha: '',
					usuario: '',
					ip: '',
					estatus: '',
					aseguradora: '',
					cliente: '',
					vendedor: '',
					producto: '',
					tipoPoliza: '',
					vigenciaIni: '',
					vigenciaFin: '',
					bienAsegurado: '',
					formaPago: '',
					referencia: '',
					observaciones: '',
					sumaAsegurada: 0,
					deducible1: 0,
					deducible2: 0,
					primaNeta: 0,
					primaTotal: 0,
					totalCobrado: 0,
				},

				errors: {},
			}
		},

		methods: {
			getPolizasLog: function(){
				this.loading = true;
				var url = 'api/polizas/'+this.codigo+'/logs';

				axios.get(url)
				.then(response => {
					this.polizas = response.data;
					$('#badge-polizas-log').text(response.data.length);
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			showPoliza: function(data){
				this.form.id = data.CODIGO_POLIZA;
				this.form.correlativo = data.CORRELATIVO_LOG;
				this.form.fecha = data.FECHA_CREACION;
				this.form.usuario = data.usuario ? data.usuario.NOMBRE : '';
				this.form.ip = data.CREADO_DESDE;
				this.form.aseguradora = data.aseguradora ? data.aseguradora.DESCRIPCION_ASEGURADORA : '';
				this.form.estatus = data.ESTATUS == 'V' ? 'Vigente' : 'No Vigente';
				this.form.cliente = data.cliente ? data.cliente.NOMBRE_CLIENTE : '';
				this.form.vendedor = data.vendedor ? data.vendedor.NOMBRE_VENDEDOR : '';
				this.form.producto = data.producto ? data.producto.DESCRIPCION_PRODUCTO : '';
				this.form.tipoPoliza = data.tipo_poliza ? data.tipo_poliza.DESCRIPCION : '';
				this.form.vigenciaIni = data.FECHA_VIGENCIA_INI;
				this.form.vigenciaFin = data.FECHA_VIGENCIA_FIN;
				this.form.bienAsegurado = data.BIEN_ASEGURADO;
				this.form.formaPago = data.forma_pago ? data.forma_pago.DESCRIPCION_FORMA_PAGO : '';
				this.form.referencia = data.CODIGO_POLIZA_REF;
				this.form.observaciones = data.OBSERVACIONES;
				this.form.sumaAsegurada = data.SUMA_ASEGURADA;
				this.form.deducible1 = data.DEDUCIBLE1;
				this.form.deducible2 = data.DEDUCIBLE2;
				this.form.primaNeta = data.PRIMA_NETA;
				this.form.primaTotal = data.PRIMA_TOTAL;
				this.form.totalCobrado = data.TOTAL_COBRADO;

				$('#modalPolizaLog').modal('show');

			},

			openModalPoliza: function(){
				$('#modalPolizaLog').modal('show');
			},

			closeModalPoliza: function(){
				$('#modalPolizaLog').modal('hide');
			},
		},

		computed: {
            oportunidad: function () {
            	return JSON.parse(this.data);
            },

            codigoProducto: function(){
            	return this.producto;
            },
        },

        watch: {
        	poliza: function(val){
        		if (val) {
        			this.codigo = val;
        			this.getPolizasLog();
        		}
        	},
  		}
	}
</script>